import { createAction } from 'redux-act';

export const handleError = createAction('Handle error');
export const setError = createAction('Set error');
export const errorReset = createAction('Reset error');
